import loadable from "@loadable/component";

import { Loading, ErrorBoundary } from "../components";
import { Props, loadData } from "./Request";

const Request= loadable(() => import("./Request"), {
  fallback: <Loading />
});

export default (props: Props): JSX.Element => (
  <ErrorBoundary>
    <Request {...props} />
  </ErrorBoundary>
);
export { loadData };
